import ard_4 from '../assets/Rides Pics/ard_4.png'
import ard_ext from '../assets/Rides Pics/ard_ext.jpg'
import bull from '../assets/Rides Pics/bull.jpg'
import chair from '../assets/Rides Pics/chair.png'
import face from '../assets/Rides Pics/face.jpg'
import farm from '../assets/Rides Pics/farm.jpg'
import kids_gym from '../assets/Rides Pics/kids_gym.jpg'
import laser from '../assets/Rides Pics/laser.jpg'
import ninja from '../assets/Rides Pics/ninja.jpg'
import playland from '../assets/Rides Pics/playland.jpg'
import pony from '../assets/Rides Pics/pony.jpg'
import rock_wall from '../assets/Rides Pics/rock_wall.jpg'
import slide from '../assets/Rides Pics/slide.jpg'
import stunt from '../assets/Rides Pics/stunt.jpg'
import zoo from '../assets/Rides Pics/zoo.jpg'
import castle from '../assets/Rides Pics/castle.png'

export const colors = {
    mustard: '#fac55f',
    red: '#f2625b',
    teal: '#34bdab'
}

export const imageMap = {
    ard_4,
    ard_ext,
    bull,
    chair,
    face,
    farm,
    kids_gym,
    laser,
    ninja,
    playland,
    pony,
    rock_wall,
    slide,
    stunt,
    castle,
    zoo
}

export const Timestamps = {
    Saturday: 1690574400000,
    Sunday: 1690660800000
}